// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { FetchModelResponse, IFetchModel } from '@cian/http-api';
import type { IGetProjectsListV2Response } from '../../entities/v2_entities/GetProjectsListV2Response';
import type { IErrorResponseSchema } from '../../entities/schemas/ErrorResponseSchema';

export interface IGetProjectsListRequest {
  areaFrom?: number;
  areaTo?: number;
  floors?: EQueryParameters[];
  limit?: number;
  materials?: EQueryParameters_1[];
  page?: number;
  priceFrom?: number;
  priceTo?: number;
  regionId?: number;
  subdomain?: string;
  withOpenVillage?: boolean;
}

export enum EQueryParameters {
  /** Один **/
  'One' = 'one',
  /** Два **/
  'Two' = 'two',
  /** Три и более **/
  'ThreeAndMore' = 'threeAndMore',
}
export enum EQueryParameters_1 {
  /** Блоки **/
  'Blocks' = 'blocks',
  /** Кирпич **/
  'Brick' = 'brick',
  /** Клееный брус **/
  'GluedLaminatedTimber' = 'gluedLaminatedTimber',
  /** Цельное дерево (бревно или брус) **/
  'SolidTree' = 'solidTree',
  /** Каркасные дома **/
  'FrameHouses' = 'frameHouses',
  /** Монолит **/
  'Monolith' = 'monolith',
  /** СИП технологии **/
  'Sip' = 'sip',
  /** Другое **/
  'Other' = 'other',
}
export type TGetProjectsListResponse =
  | FetchModelResponse<200, 'json', IGetProjectsListV2Response>
  | FetchModelResponse<400, 'json', IErrorResponseSchema>;

export type TGetProjectsListModel = IFetchModel<IGetProjectsListRequest, undefined, TGetProjectsListResponse>;

export interface IMappers<TResponse200, TResponse400> {
  200(response: IGetProjectsListV2Response, headers: Headers): TResponse200;
  400(response: IErrorResponseSchema, headers: Headers): TResponse400;
}
